<div class="container-fluid mb-5 px-3">
    <div class="mt-3 d-flex justify-content-between">
        <div class="font-weight-bold">
            <h1>Price Rates</h1>
        </div>
        <div class="d-flex mt-2 me-1">
            <button mat-raised-button class="action-button d-flex col-auto align-items-center" (click)="onNewPriceRateClick()">
                <mat-icon>add</mat-icon>
                Add Price Rate
            </button>
        </div>
    </div>
    <mat-card class="mt-3 pb-5">
        <div class="row justify-content-center">
            <div class="col-12 mb-3">
                <mat-tab-group dynamicHeight [preserveContent]="true">
                    <mat-tab label="Underwriter">
                        <div class="row justify-content-end p-3">
                            <div class="col-3 my-2">
                                <mat-form-field appearance="outline" class="search-bar">
                                    <mat-label class="search-bar-label">
                                        <mat-icon class="search-icon">search</mat-icon>
                                        <span>Search</span>
                                    </mat-label>
                                    <input matInput (keyup)="applyUnderwriterSearch($event)" [(ngModel)]="underwriterSearchKeyword">
                                    <button type="button" *ngIf="underwriterSearchKeyword" matSuffix mat-icon-button aria-label="Clear" (click)="clearUnderwriterSearch()">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                            <div class="mt-2 mb-3">
                                <div class="table-responsive">
                                    <table mat-table matSort [dataSource]="underwriterDataSource" class="mat-elevation-z8">
                                        <ng-container [matColumnDef]="column.column" *ngFor="let column of underwriterDisplayedColumns">
                                            <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ column.display }}</th>
                                            <ng-container [ngSwitch]="column.column">
                                                <ng-container *ngSwitchCase="'price'">
                                                    <td mat-cell *matCellDef="let element">
                                                        {{ element[column.column] | currency }}
                                                    </td>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'deductible'">
                                                    <td mat-cell *matCellDef="let element">
                                                        {{ element[column.column] | currency }}
                                                    </td>
                                                </ng-container>
                                                <ng-container *ngSwitchDefault>
                                                    @if(column.renderHtml) {
                                                        <td mat-cell *matCellDef="let element" [innerHTML]="element[column.column]"></td>
                                                    } @else {
                                                        <td mat-cell *matCellDef="let element">{{ element[column.column] }}</td>
                                                    }
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="displayedUnderwriterColumnNames"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedUnderwriterColumnNames;" (click)="onRowClick(row)"></tr>
                                        @if(loading && underwriterSearchKeyword) {
                                            <tr class="mat-row" *matNoDataRow>
                                                <td class="mat-cell" colspan="12" style="padding:26px; text-align:center;">
                                                    No data matching the filter "{{ underwriterSearchKeyword }}"
                                                </td>
                                            </tr>
                                        }
                                        @if (loading && !underwriterSearchKeyword) {
                                            <tr class="mat-row" *matNoDataRow>
                                                <td class="mat-cell" colspan="12" style="padding:26px; text-align:center;">
                                                    Loading Price Rates..
                                                </td>
                                            </tr>
                                        }
                                    </table>
                                </div>
                                <div *ngIf="loading.value" class="d-flex justify-content-center">
                                    <mat-spinner></mat-spinner>
                                </div>
                                <div class="d-flex paginator-row align-items-baseline">
                                    <div class="col-10">
                                        <mat-paginator (page)="onPageEvent($event)" [pageSizeOptions]="[10, 20, 50, 100]" [pageSize]="underwriterPageSize || 10" [length]="underwriterTableLength" aria-label="Select page" showFirstLastButtons></mat-paginator>
                                    </div>
                                    <div class="col-2 d-flex align-items-baseline">
                                        <mat-form-field class="go-to" id="goToPage" style="width:90px;">
                                            <input type="number" matInput class="go-to-input" placeholder="Page" [(ngModel)]="underwriterPageNumber" step="1">
                                        </mat-form-field>
                                        <button mat-raised-button (click)="onGoToUnderwriterPageClick()" class="action-button">Go</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab label="Property Manager">
                        <ng-template matTabContent>
                            <app-property-manager-table></app-property-manager-table>
                        </ng-template>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </mat-card>
</div>